import { createContext } from 'react';

const KomunikatorContext = createContext({
  addNewChat: () => {}
});
KomunikatorContext.displayName = 'KomunikatorContext';

export default KomunikatorContext